import type { SVGProps } from "react";

export function IconDarkPurplePaymentCardCheck(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6191_13065)">
        <path
          d="M17 26.125H6C4.48122 26.125 3.25 24.8938 3.25 23.375V6.875C3.25 5.35622 4.48122 4.125 6 4.125H28C29.5188 4.125 30.75 5.35622 30.75 6.875V19.9375"
          stroke="#3E2247"
          strokeWidth="2.0625"
        />
        <path d="M3.25 11.6875H30.75" stroke="#3E2247" strokeWidth="2.0625" />
        <path
          d="M6.6875 21.3125H13.5625"
          stroke="#3E2247"
          strokeWidth="2.0625"
        />
        <circle
          cx="24.5625"
          cy="24.0625"
          r="7.5625"
          stroke="#3E2247"
          strokeWidth="2.0625"
        />
        <path
          d="M27.8125 23.1875L24.375 26.625L22.3125 24.5625"
          stroke="#3E2247"
          strokeWidth="2.0625"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_6191_13065">
          <rect
            width="33"
            height="33"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
